<template>
  <div id="app">
    <da-header></da-header>
    <div class="container-principal">
      <router-view></router-view>
    </div>
    <da-footer></da-footer>
  </div>
</template>

<script>
import DaHeader from './components/Header.vue'
import DaFooter from './components/Footer.vue'

export default {
  name: 'app',
  components: { DaHeader, DaFooter },
  data () {
    return {
     
    }
  }
}
</script>

<style lang="scss">
  @import './scss/main.scss';
  .container-principal {
    min-height: calc(100vh - 180px);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue